<div class="copo-datacenter-flex-box copo-offer-margin-bottom">
	<div class="copo-datacenter-grid-container">
		<ag-grid-angular
			class="ag-theme-balham copo-offer-table-inner-margin"
			[gridOptions]="gridOptions"
			[modules]="agGridModules"
			(gridReady)="onGridReady($event)"
			(viewportChanged)="onViewportChanged($event)">
		</ag-grid-angular>
	</div>
</div>